module.exports = __webpack_public_path__ + "img/button-mydr.30de138a.svg";